/* eslint-disable react/prop-types */
import { AuthContext } from 'context/AuthContext';
import React, { useContext } from 'react';
import { Can as CoreCan } from '@casl/react';

// eslint-disable-next-line react/prop-types
const Can = ({ children, I, this: subject, ...props }) => {
  const { abilities } = useContext(AuthContext);

  // Handle case where I is an array of actions
  if (Array.isArray(I)) {
    // Check if user has permission for any action in the array
    const hasPermission = I.some(action => abilities.can(action, subject));

    // Only render children if user has permission for at least one action
    return hasPermission ? <>{children}</> : null;
  }

  // Original behavior for single action
  return (
    <CoreCan {...props} I={I} this={subject} ability={abilities}>
      {children}
    </CoreCan>
  );
};

export default Can;
